<span *ngIf="scan.contents.article"  class="request-word-wrapper">
    {{ scan.contents.article }}
</span>
<span *ngIf="!scan.contents.article" translate>
    No article
</span>

